import React, { useEffect, useState } from "react";
import { Pressable, Text, View, Image, ScrollView } from "react-native";
import { getImagePath } from "../../utils/services/CommonUtils";
import { getPaymentOffersAndModes } from "../../utils/services/payment/PaymentOfferUtils";

import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { CommonZeroScreen } from "../zero-screens/CommonZeroScreen";
import { CommonRightChevronIcon } from "../../utils/widgets/Common-Widget";

import { ScreenRoute } from "../../utils/constants/ScreenRouteConstant";

import AppTheme from "../../AppTheme";
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";

import * as Animatable from "react-native-animatable";

const OffersList = (props) => {

    const [offersList, updateOffersList] = useState([])
    const [isLoading, setLoader] = useState(true)

    const setOfferBackgroundColor = (index) => {
        let backgroundColorList = [
            AppTheme.color.orange.bg,
            AppTheme.color.blue.bg,
            AppTheme.color.green.bg,
            AppTheme.color.red.bg,
        ]
        return backgroundColorList[index % 4]
    }

    const getPaymentOffers = () => {
        setLoader(true)
        getPaymentOffersAndModes().then((response: any) => {
            updateOffersList(response['offers'])
            setLoader(false)
        })
    }

    useEffect(() => {
        getPaymentOffers()
    }, [])

    return (
        <View>

            <CommonHeader title={'Offers'} navigation={props.navigation} />

            <ScrollView style={[{ marginTop: AppTheme.headerHeight, paddingVertical: 16 }]}>

                {isLoading ? null : offersList.length > 0 ?
                    offersList.map((offer, index) => (
                        <Animatable.View animation="fadeIn"
                            duration={AppTheme.transitionDuration}
                            delay={index ? (index * AppTheme.transitionDuration) / 20 : 0}
                            useNativeDriver
                            key={offer['code']}
                            style={[AppStyles.alignCenter, {
                                width: AppTheme.appWidth - 14,
                                marginBottom: 12
                            }]}>
                            <Pressable onPress={() => { props.navigation.navigate(ScreenRoute.selected_offer, { offer: offer }) }}
                                style={[{
                                    borderRadius: 12, alignSelf: "center",
                                    backgroundColor: setOfferBackgroundColor(index),
                                    width: AppTheme.appWidth - 32
                                },
                                {
                                    paddingTop: 12, paddingBottom: 15,
                                    paddingLeft: 24, paddingRight: 16
                                }]}>

                                <View style={[AppStyles.flexRowStart]}>
                                    <Image style={{ height: 32, width: 32 }}
                                        source={{ uri: getImagePath('/images/icons/order_circle_blue.svg') }} />
                                    <View style={{
                                        borderRadius: 4, borderWidth: 2, borderStyle: "dashed",
                                        borderColor: AppTheme.color.primary, marginLeft: 12,
                                        paddingVertical: 6, paddingHorizontal: 14
                                    }}>
                                        <Text style={[TextStyle.text14b]}>
                                            {offer['code']}
                                        </Text>
                                    </View>
                                </View>

                                <Text style={[TextStyle.text14b, { marginTop: 12 }]}>
                                    {offer['title']}
                                </Text>

                                <View style={[AppStyles.flexRowSpaceBetween, { marginTop: 8 }]}>

                                    <Text style={[TextStyle.text12]}>
                                        {offer['subTitle']}</Text>
                                    {CommonRightChevronIcon('black')}

                                </View>

                            </Pressable>
                            <View style={{
                                width: 18, height: 18, borderRadius: 18,
                                backgroundColor: AppTheme.color.white,
                                position: "absolute", left: 0
                            }} />
                            <View style={{
                                width: 18, height: 18, borderRadius: 18,
                                backgroundColor: AppTheme.color.white,
                                position: "absolute", right: 0
                            }} />
                        </Animatable.View>
                    )) : <CommonZeroScreen screenName={'noOffer'} />
                }

            </ScrollView>

        </View>
    )
}

export default OffersList